/**
 * Welche Kommentarspalten aufgeklappt bleiben (PO 20.09.2026: „ja" auf die
 * Frage, ob die Spalte sich das merkt).
 *
 * ══ JE BROWSER, NICHT JE KONTO ═════════════════════════════════════════════
 * Gemerkt wird im `localStorage`, nicht am Server. „Welche Mail habe ich
 * aufgeklappt" ist eine Ansichtssache dieses Fensters — eine Einstellung am
 * Konto brächte einen Endpunkt, eine Tabelle und eine Migration für etwas,
 * das beim Wechsel des Rechners niemand vermisst.
 *
 * DER SPEICHER KANN FEHLEN. Im privaten Fenster, bei gesperrten Seitendaten
 * und in der Vorschau wirft schon der Zugriff. Jede Berührung liegt deshalb in
 * `try/catch`, und ohne Speicher verhält sich die Spalte wie am ersten Tag:
 * alles zugeklappt. Das ist kein Fehler, den jemand sehen müsste.
 * ═══════════════════════════════════════════════════════════════════════════
 */

/** Der Ablageort. Ein Name, damit ihn die Suche findet. */
export const SPEICHER_SCHLUESSEL = "kmvs.vg4.kommentarAuf";

/**
 * Wie viele Schlüssel gemerkt werden. Ohne Deckel wüchse die Liste mit jedem
 * aufgeklappten Faden weiter und stünde nach einem Jahr mit Tausenden von
 * Einträgen im Speicher, von denen die meisten Vorgänge längst erledigt sind.
 * Voll heißt: der ÄLTESTE fliegt.
 */
export const DECKEL = 300;

/**
 * Den gemerkten Stand anwenden: jüngste Berührung ans Ende.
 *
 * REIN — das Rechnen ist geprüft, das Lesen und Schreiben daneben nicht.
 */
export function mitStand(bestand: string[], schluessel: string, auf: boolean): string[] {
    const ohne = bestand.filter((k) => k !== schluessel);
    if (!auf) return ohne;
    const next = [...ohne, schluessel];
    return next.length > DECKEL ? next.slice(next.length - DECKEL) : next;
}

/** Was im Speicher steht; leer, wenn es ihn nicht gibt oder er Unsinn enthält. */
export function lies(): string[] {
    try {
        const roh = window.localStorage.getItem(SPEICHER_SCHLUESSEL);
        if (!roh) return [];
        const arr = JSON.parse(roh);
        if (!Array.isArray(arr)) return [];
        return arr.filter((x): x is string => typeof x === "string").slice(-DECKEL);
    } catch {
        return [];
    }
}

/** Den Stand ablegen. Schlägt es fehl, bleibt es beim Stand dieser Sitzung. */
export function schreibe(liste: string[]): void {
    try {
        window.localStorage.setItem(SPEICHER_SCHLUESSEL, JSON.stringify(liste));
    } catch {
        /* defensiv: ohne Speicher merkt sich die Spalte eben nichts */
    }
}
